export class BotionError extends Error {
    event;
    data;
    constructor(event, data) {
        super(`BotionError: ${event} ${JSON.stringify(data)}`);
        this.event = event;
        this.data = data;
    }
}
//# sourceMappingURL=BotionError.js.map